import { useList, useDetail, useCreate, useUpdate, useDelete, useListInfinite, useAction } from "@inmagik/react-crud"
import { HistoricalInfo, Produttore } from "../types"
import { API_URL } from "../constants"

export function useProduttoriList(params: Record<string, string> = {}) {
  return useList<Produttore>(`${API_URL}/produttori`, {
    query: params,
  })
}

export function useProduttore(id: number | undefined | string) {
  return useDetail<Produttore>(`${API_URL}/produttori`, id?.toString())
}

export function useProduttoreCreate() {
  return useCreate<Produttore>(`${API_URL}/produttori`)
}

export function useProduttoreUpdate() {
  return useUpdate<Produttore>(`${API_URL}/produttori`)
}

export function useProduttoreDelete() {
  return useDelete<Produttore>(`${API_URL}/produttori`)
}

export function useProduttoreHistory(id: number | string) {
  return useListInfinite<HistoricalInfo>(`${API_URL}/produttori/${id}/history`)
}

export function useProduttoreSetAllegati(id: number | string){
  return useAction(`${API_URL}/produttori/${id}/set-allegati`, {
    method: "POST",
    encode: 'formdata'
  })
}


export function useDownloadProduttori(params: Record<string, string> = {}) {
  return useAction<Blob, void>(`${API_URL}/produttori/download`, {
    method: "GET",
    query: params,
    responseType: "blob",
  })
}
